import { ApproximateValueEntity } from '../entities/approximate-value-entity';

export default class State {
  items: Array<ApproximateValueEntity> = [];
}
